let counter = 0;

/** Monotonic local id, fast — good for entities, sound instances, etc. */
export const nextId = (prefix = "id"): string => `${prefix}_${(++counter).toString(36)}`;

/** Random short id for client-generated tags. Not a UUID — do not use as security token. */
export const shortId = (): string =>
  Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
